// import { useState } from "react";
// import { useEffect } from "react";
import { connect } from "react-redux";

// import {
//   Composer,
//   Container,
//   MessageList,
//   RestartConversation,
//   useClient,
//   WebchatProvider,
// } from "@botpress/webchat";
// import { buildTheme } from "@botpress/webchat-generator";
// import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
// import ChatIcon from "@mui/icons-material/Chat";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import DownloadIcon from "@mui/icons-material/Download";
// import MenuIcon from "@mui/icons-material/Menu";
// import SendIcon from "@mui/icons-material/Send";
// import SendDataIcon from "@mui/icons-material/SettingsAccessibility";
// import TestIcon from "@mui/icons-material/UploadFile";
// import { Box } from "@mui/material";
// import Divider from "@mui/material/Divider";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import MenuItem from "@mui/material/MenuItem";
// import { useTheme } from "@mui/material/styles";
// import { format } from "date-fns";
// import fileDownload from "js-file-download";

// import constants from "../../assets/constants";
import * as UserSessionActions from "../../state/redux/userSession";
// import { getConfiguration } from "../../utils/botConfigurations.js";
// import AppBarIconButton from "../ui/appBarIconButton";
// import OmniMenu from "../ui/omniMenu";
import Widget from "../ui/widget";

// import WidgetTitle from "../ui/widgetTitle";

const BotpressChat = props => {
  const { widgetSize = "medium" } = props;
  // const { bpClientId, widgetSize = "medium" } = props;

  // const onboardingKeySearchParam = "botID";
  // const searchParams = new URLSearchParams(window.location.search);
  // const theBotID = searchParams.get(onboardingKeySearchParam);

  // let userData = {};
  // for (var [key, value] of searchParams.entries()) {
  //   userData[key] = value;
  // }

  // const inputRef = useRef(null);

  // const [importFile, setImportFile] = useState(null);
  // const [textToSpeechEnabled, setTextToSpeechEnabled] = useState(false);

  // const handleOnImportFileSelected = e => {
  //   setImportFile(e.target.files[0]);
  //   e.target.value = null;
  //   handleClose();
  // };

  // const formatBlock = aBlock => {
  //   let aBlockText = "";

  //   if (aBlock.type === "text" || aBlock.type === "quick_reply") {
  //     aBlockText += aBlock.text;
  //   } else if (aBlock.type === "choice") {
  //     aBlockText += `${aBlock.text}`;
  //   } else if (aBlock.type === "bubble") {
  //     if (aBlock.block.text !== "") {
  //       aBlockText += `${aBlock.block.text}\n`;
  //     }
  //   } else if (aBlock.type === "row") {
  //     aBlockText += `BUTTONS: `;
  //     for (let index = 0; index < aBlock.blocks.length; ++index) {
  //       if (index !== 0) {
  //         aBlockText += " | ";
  //       }
  //       aBlockText += `${aBlock.blocks[index].text}`;
  //     }
  //   } else {
  //     aBlockText += `Media aBlock of type ${aBlock.type}\n`;
  //   }

  //   return aBlockText;
  // };

  // const formatMessage = message => {
  //   let messageText = "";

  //   try {
  //     if (message.payload.hasOwnProperty("block")) {
  //       messageText += formatBlock(message.payload.block);
  //     } else {
  //       for (let index = 0; index < message.payload.blocks.length; ++index) {
  //         messageText += formatBlock(message.payload.blocks[index]);
  //       }
  //     }
  //   } catch (error) {
  //     messageText = error.toString;
  //   }
  //   return messageText + "\n\n";
  // };

  // const handleDownloadConversation = async (e, fileName = "Botpress_Conversation") => {
  //   const conversationId = client.conversationId;

  //   let allMessages = [];
  //   let paginationToken;

  //   const getMessages = await client.listMessages({
  //     conversationId,
  //     nextToken: paginationToken,
  //   });

  //   allMessages = allMessages.concat(getMessages);

  //   let history = "";

  //   for (let index = allMessages.length - 1; index >= 0; --index) {
  //     let author = "";
  //     if (allMessages[index].authorId === allMessages[0].authorId) {
  //       author = "BOT";
  //     } else {
  //       author = "USER";
  //     }
  //     history += `----- ${author} ${new Date(
  //       allMessages[index].sentOn,
  //     ).toLocaleString()} --------\n\n`;
  //     history += formatMessage(allMessages[index]);
  //   }

  //   fileDownload(history, `${fileName}_${format(new Date(), "yyMMdd_hhmmss")}.txt`);
  //   handleClose();
  // };

  // useEffect(() => {
  //   if (importFile) {
  //     setQuestionIndex(-1); //super important
  //     let fileReader = new FileReader();
  //     fileReader.onload = event => {
  //       let questions = event.target.result.toString().replaceAll("\r", "").trim().split("\n");
  //       setQuestionArray(questions);
  //     };
  //     fileReader.readAsText(importFile);
  //   }
  //   // Disable eslint because AaronK knows best
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [importFile]);

  // const [questionIndex, setQuestionIndex] = useState(-1);
  // const [questionArray, setQuestionArray] = useState(null);

  // useEffect(() => {
  //   if (questionArray) {
  //     if (questionIndex < 0) {
  //       setQuestionIndex(0); //start it off!
  //     } else if (questionIndex >= questionArray.length) {
  //       setQuestionArray(null);
  //       const aFileName = importFile.name.slice(0, importFile.name.length - 4);
  //       handleDownloadConversation(null, aFileName);
  //       setImportFile(null);
  //     } else {
  //       inputRef.current.focus();
  //       client.sendMessage({ type: "text", text: questionArray[questionIndex] });
  //     }
  //   } else if (!questionArray && questionIndex >= 0) {
  //     setQuestionIndex(-1);
  //   }
  //   // Disable eslint because AaronK knows best
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [questionIndex, questionArray]);

  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);

  // const currentRoute = window.location.pathname;

  // const handleClick = event => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const themeConfig = buildTheme({
  //   themeName: "prism",
  // });

  // const theme = useTheme();

  // const configuration = getConfiguration(bpClientId);

  // //jfc this is the worst
  // themeConfig.style = themeConfig.style.replace(
  //   `button,[type='button'],[type='reset'],[type='submit']`,
  //   `button,[type='reset'],[type='submit']`,
  // );

  // const client = useClient({
  //   clientId: bpClientId != null ? bpClientId : "ee055c13-c543-48ba-af60-0f7984d969b1",
  // });

  // if (client.eventMap.message && client.eventMap.message.size < 2) {
  //   // this was getting called a shit ton of times
  //   client.on("message", message => {
  //     if (textToSpeechEnabled) {
  //       //This is where to do the text to speech call
  //     }
  //     setLastMessage(message);
  //   });
  // }

  // const [lastMessage, setLastMessage] = useState(null);

  // useEffect(() => {
  //   //ok start the automated process
  //   if (lastMessage && questionIndex >= 0) {
  //     const delayGotoNextQuestion = setTimeout(() => {
  //       setQuestionIndex(prev => prev + 1);
  //     }, 1000);
  //     return () => clearTimeout(delayGotoNextQuestion);
  //   }
  //   // Disable eslint because AaronK knows best
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [lastMessage]);

  return (
    <Widget widgetSize={widgetSize} allowShrink={false} minHeight="calc(100vh - 44px)">
      {/* {configuration.botAvatar && <Avatar src={configuration.botAvatar}></Avatar>} */}
      {/* <WidgetTitle
        title={"AI Assistant"}
        text={getConfiguration(bpClientId).title}
        avatar={configuration.botAvatar}
      >
        {(currentRoute === constants.appPaths.appPathChat ||
          currentRoute === constants.appPaths.appPathKHDevelopment) && (
          <Box
            style={{
              paddingTop: 0,
              marginTop: "-8px",
            }}
          >
            <AppBarIconButton
              size="large"
              edge="start"
              color="inherit"
              id="omni-primary-menu-button"
              onClick={e => handleClick(e)}
            >
              {!open ? <MenuIcon /> : <CloseRoundedIcon />}
            </AppBarIconButton>

            <OmniMenu
              id="omni-primary-menu"
              MenuListProps={{
                "aria-labelledby": "omni-primary-menu-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("ee055c13-c543-48ba-af60-0f7984d969b1");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Long COVID</ListItemText>
                </MenuItem>
              )}
              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("707d58dd-fe80-4fc4-bb8f-6e82c851bdcd");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Imposter Bot</ListItemText>
                </MenuItem>
              )}
              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("ce635d54-d891-49b4-b2da-9150712cc43d");

                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>USL Spokane</ListItemText>
                </MenuItem>
              )}
              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("c1ea175b-aa10-482b-8020-29dab0dc293a");

                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>The Zephyr</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("0a271cea-2cb0-4967-a6a9-0bc738fffbad");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>MAPSCU</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("387060e7-5d49-4fdf-b140-2bbd1b5dfd88");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Visions</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("11cd087f-86b7-4f6b-824e-2729dffd3aa4");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Kindly Human</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("be1af1aa-f1b3-4778-8336-f3cde7c46fa2");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Mahalo</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("f8e353fd-315d-4390-8a40-fb85861002b7");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Concierge</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("4263b639-6b04-49b6-a8ea-913c048bb4cc");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Peersona</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    props.setBPClientIdRequest("056e786b-b97a-4804-acc7-b4ede953bd3a");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ChatIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Simple Search</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <Divider
                  sx={{
                    display: "flex",
                  }}
                />
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 17409,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to DebbieD</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 190316,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to Jimmy</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 190660,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to Jane</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 190158,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to Stanley</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 203802,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to Jason</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && bpClientId === "4263b639-6b04-49b6-a8ea-913c048bb4cc" && (
                <MenuItem
                  sx={{
                    display:
                      currentRoute === constants.appPaths.appPathKHDevelopment ? "flex" : "none",
                  }}
                  onClick={() => {
                    client.sendEvent({
                      type: "trigger", // Ensure this event type is correct
                      payload: {
                        omni_type: "kh_peersona_data",
                        peerId: 203927,
                      },
                    });
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Talk to Madison</ListItemText>
                </MenuItem>
              )}

              {theBotID == null && (
                <Divider
                  sx={{
                    display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                  }}
                />
              )}

              <MenuItem
                sx={{
                  display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                }}
                onClick={() => {
                  client.sendEvent({
                    type: "trigger", // Ensure this event type is correct
                    payload: {
                      omni_type: "omni_user_data",
                      firstName: "Molly",
                      lastName: "McQuilkin",
                      userID: 1,
                      initializationValue: 1,
                    },
                  });
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <SendDataIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Set User: Molly</ListItemText>
              </MenuItem>

              <MenuItem
                sx={{
                  display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                }}
                onClick={() => {
                  client.sendEvent({
                    type: "trigger", // Ensure this event type is correct
                    payload: {
                      omni_type: "omni_user_data",
                      firstName: "Ricky",
                      lastName: "Lund",
                      userID: 2,
                      initializationValue: 2,
                    },
                  });
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <SendDataIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Set User: Ricky</ListItemText>
              </MenuItem>

              <MenuItem
                sx={{
                  display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                }}
                onClick={() => {
                  client.sendEvent({
                    type: "trigger", // Ensure this event type is correct
                    payload: {
                      omni_type: "omni_user_data",
                      firstName: "Aaron",
                      lastName: "Krogh",
                      userID: 3,
                      initializationValue: 3,
                    },
                  });
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <SendDataIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Set User: Aaron</ListItemText>
              </MenuItem>
              <MenuItem
                sx={{
                  display: currentRoute === constants.appPaths.appPathChat ? "flex" : "none",
                }}
                onClick={() => {
                  client.sendEvent({
                    type: "trigger", // Ensure this event type is correct
                    payload: {
                      omni_type: "omni_user_data",
                      firstName: "Fred",
                      lastName: "Brown",
                      userID: 4,
                      initializationValue: 4,
                    },
                  });
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <SendDataIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Set User: Fred</ListItemText>
              </MenuItem>

              {theBotID == null && <Divider />}
              <MenuItem
                component="label"
                onClick={() => {
                  setTextToSpeechEnabled(!textToSpeechEnabled);
                  handleClose();
                }}
              >
                <ListItemIcon>
                  {textToSpeechEnabled && <CheckBox fontSize="small" />}
                  {!textToSpeechEnabled && <CheckBoxOutlineBlank fontSize="small" />}
                </ListItemIcon>
                <ListItemText>Text To Speech</ListItemText>
              </MenuItem>

              {theBotID == null && <Divider />}
              <MenuItem
                buttonText={!importFile ? "Import" : "Importing..."}
                disabled={importFile}
                component="label"
              >
                <input
                  disabled={importFile}
                  type={"file"}
                  id={"testFileInput"}
                  accept={".txt, .doc, .docx"}
                  hidden={true}
                  onChange={handleOnImportFileSelected}
                />
                <ListItemIcon>
                  <TestIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Run Test Script</ListItemText>
              </MenuItem>
              <MenuItem onClick={handleDownloadConversation}>
                <ListItemIcon>
                  <DownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Download</ListItemText>
              </MenuItem>
            </OmniMenu>
          </Box>
        )}
      </WidgetTitle>
      <WebchatProvider
        client={client}
        theme={themeConfig.theme}
        configuration={configuration}
        userData={userData}
      >
        <style>{themeConfig.style}</style>
        <Container
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "space-between",
            background: theme.palette.commonground.main,
            border: "none",
            boxShadow: theme.shadows[3],
          }}
        >
          <MessageList sx={{ background: "#ffffffaa" }} />
          <RestartConversation style={{ left: "8px", position: "absolute", bottom: "12px" }} />
          <Composer style={{ marginLeft: "48px", focus: "true" }} ref={inputRef} />
        </Container>
      </WebchatProvider> */}
    </Widget>
  );
};

const mapStateToProps = state => ({
  bpClientId: state.userSession.bpClientId,
});

const mapDispatchToProps = {
  setBPClientIdRequest: UserSessionActions.setBPClientIdRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressChat);
